<template>
  <div>
    <el-select
      clearable
      v-model="PaymentOrInvoiceType"
      placeholder="Tipo Pagos/Facturas"
      @change="handlePaymentsTypeSelection"
      v-bind="$attrs"
      size="mini"
    >
      <!-- <el-option :key="0" :value="0" label="Todos"></el-option> -->
      <el-option
        v-for="item in PaymentsAndInvoicesTypes"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "PaymentAndInvoiceTypeSelector",

  data() {
    return {
      PaymentOrInvoiceType: 2,
      PaymentsAndInvoicesTypes: [
        { label: "Pagos", value: 2 },
        { label: "Facturas", value: 1 }
      ]
    };
  },

  mounted() {},

  methods: {
    handlePaymentsTypeSelection(type) {
      this.$emit("PaymentTypeSelected", type);
    }
  }
};
</script>

<style scoped></style>
